import { Form } from 'src/app/models/form.model';
import { Component, ViewChild, TemplateRef, Input } from '@angular/core';
import { PropiedadService } from '../../../services/propiedad.service';
import { Propiedad } from '../../../models/propiedad.model';
import { MatDialog, MatSelect } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { ReplaySubject, Subject, Observable } from 'rxjs';
import { take, takeUntil, map, startWith } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
interface AppState {
    form: Form;
}
@Component({
    selector: "page-propiedad",
    templateUrl: "./propiedad.component.html",
    providers: [PropiedadService, FormService]
})

export class PropiedadComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNOROL') openModalNOROL: TemplateRef<any>;
    @ViewChild('modalDirecciones') modalDirecciones: TemplateRef<any>;
    @ViewChild('openModalVerPorRol') openModalVerPorRol: TemplateRef<any>;
    @ViewChild('singleSelect') singleSelect: MatSelect;

    public invalidRol: Boolean;
    public propiedad: Propiedad;
    public rows = [];
    public actualRow;
    public direcciones = [];
    public p: number = 1;
    public searchText
    public temp_dir;
    public isopen = false;
    public rol = new FormControl('', [Validators.required]);
    public dir = new FormControl('', [Validators.required]);
    public num = new FormControl('', [Validators.required]);
    public calles = [];
    public filteredCalles: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
    public buscarCalle: FormControl = new FormControl();
    protected _onDestroy = new Subject<void>();
    myControl = new FormControl();
    options = []
    filteredOptions: Observable<string[]>;

    //bandera
    rol_dir_encontrada = false

    matcher = new FormService();

    constructor(private _PropiedadService: PropiedadService, private _router: Router, private store: Store<AppState>, public dialog: MatDialog,
        public _formService: FormService, private spinner: NgxSpinnerService) {

        if (!JSON.parse(localStorage.getItem("propiedad"))) {
            localStorage.setItem("propiedad", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("propiedad"));

        }
        this.invalidRol = true;
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
    }


    // ngOnDestroy() {
    //     this._onDestroy.next();
    //     this._onDestroy.complete();
    // }


    ngOnInit() {
        this.traerCalles()
        this.filteredOptions = this.dir.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }


    private _filter(value: string): string[] {
        if (value != null) {
            const filterValue = value.toLowerCase();
            return this.options.filter(option => option.toLowerCase().includes(filterValue));
        }
    }
    getPropiedad_rol() {
        //console.log("get propiedad rol()",)
        this.spinner.show()
        this._PropiedadService.getPropiedad(this.rol.value, undefined, undefined, undefined).subscribe(
            response => {
                //console.log("getpropiedadrol response:",response)
                if (response.direcciones) {
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);
                    this.spinner.hide()
                } else {
                    if (response.message) {

                        this.propiedad.rol = this.rol.value ? this.rol.value : '';
                        this.rol_dir_encontrada = false
                        this.spinner.hide()
                        this.dialog.open(this.openModalNOROL);




                    } else {

                        this.propiedad.rol = response.rol ? response.rol : '';
                        this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedad.folio = response.folio ? response.folio : '';
                        this.propiedad.calle = response.calle ? response.calle : '';
                        this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                        this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedad.loteo = response.loteo ? response.loteo : '';
                        this.propiedad.manzana = response.manzana ? response.manzana : '';
                        this.propiedad.plano = response.plano ? response.plano : '';
                        this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedad.recordId = response.recordId ? response.recordId : '';

                        this.rol_dir_encontrada = true

                        this.dialog.open(this.openModal);
                        this.spinner.hide()
                    }
                }


            },
            error => {
                let e = JSON.parse(error._body);
                console.log(error)
                this.spinner.hide()
            }
        )
    }

    getPropiedad_por_rol(rol, id) { //3900-32
        //console.log("getpropiedad_por_rol")
        this.spinner.show()
        this._PropiedadService.getPropiedad(rol, id, undefined, undefined).subscribe(
            response => {
                //console.log("getpropiedad_por_rol response",response);
                //console.log("response.id",response.id)
                //console.log("response.rol",response.rol)
                if (response.direcciones) {
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);
                    this.spinner.hide()

                } else {
                    if (response.message) {
                        this.propiedad.rol = this.rol.value ? this.rol.value : '';
                        this.rol_dir_encontrada = false
                        this.dialog.open(this.openModalVerPorRol);
                        this.spinner.hide()

                    } else {

                        this.propiedad.rol = response.rol ? response.rol : '';
                        this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedad.folio = response.folio ? response.folio : '';
                        this.propiedad.calle = response.calle ? response.calle : '';
                        this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                        this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedad.loteo = response.loteo ? response.loteo : '';
                        this.propiedad.manzana = response.manzana ? response.manzana : '';
                        this.propiedad.plano = response.plano ? response.plano : '';
                        this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedad.recordId = response.recordId ? response.recordId : '';

                        this.rol_dir_encontrada = true
                        //console.log("rol_dir_encontrada",this.rol_dir_encontrada);

                        this.dialog.open(this.openModalVerPorRol);
                        this.spinner.hide()
                    }
                }


            },
            error => {
                console.log(error)
                this.spinner.hide()
            }
        )
    }

    getPropiedad_dir() {
        this.spinner.show();
        this._PropiedadService.getPropiedad(undefined, undefined, this.dir.value.trim(), this.num.value.trim()).subscribe(
            response => {

                this.spinner.hide()

                if (response.direcciones) {
                    //console.log("entre en 1")
                    this.direcciones = response.direcciones;
                    this.dialog.open(this.modalDirecciones);

                } else {
                    if (response.message) {

                        //console.log("entre en 2")
                        //this.propiedad.dir = dir ? dir : '';
                        // this.propiedad.num = num ? num : '';
                        this.propiedad.calle = this.dir.value ? this.dir.value : '';
                        this.rol_dir_encontrada = false
                        this.propiedad.calle_num = this.num.value ? (this.num.value === '0' ? '' : this.num.value) : '';
                        this.dialog.open(this.openModalNOROL);

                    } else {
                        //console.log("entre en 3")
                        this.propiedad.rol = response.rol ? response.rol : '';
                        this.propiedad.id_direcc = response.id_direcc ? response.id_direcc : '';
                        this.propiedad.folio = response.folio ? response.folio : '';
                        this.propiedad.calle = response.calle ? response.calle : '';
                        this.propiedad.calle_num = response.calle_num ? (response.calle_num === '0' ? '' : response.calle_num) : '';
                        this.propiedad.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                        this.propiedad.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                        this.propiedad.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                        this.propiedad.loteo = response.loteo ? response.loteo : '';
                        this.propiedad.manzana = response.manzana ? response.manzana : '';
                        this.propiedad.plano = response.plano ? response.plano : '';
                        this.propiedad.ubicacion = response.ubicacion ? response.ubicacion : '';
                        this.propiedad.recordId = response.recordId ? response.recordId : '';

                        this.rol_dir_encontrada = true
                        this.dialog.open(this.openModal);
                        this.isopen = false;
                    }
                }

            },
            error => {
                console.log(error);
                this.spinner.hide()
                this.isopen = false;
            }
        )
    }

    cleanData() {
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
    }

    savePropiedad() {

        $("#dir_modal").modal("hide");
        this.actualRow = localStorage.getItem("propiedad");
        this.rows = JSON.parse(this.actualRow);
        if (this.rol_dir_encontrada) {
            this.rows = [{
                rol: this.propiedad.rol,
                id_direcc: this.propiedad.id_direcc,
                folio: this.propiedad.folio,
                calle: this.propiedad.calle,
                calle_num: this.propiedad.calle_num,
                direccion_completa: this.propiedad.direccion_completa,
                direc_complemento: this.propiedad.direc_complemento,
                direc_compl_num: this.propiedad.direc_compl_num,
                loteo: this.propiedad.loteo,
                manzana: this.propiedad.manzana,
                plano: this.propiedad.plano,
                ubicacion: this.propiedad.ubicacion,
                recordId: this.propiedad.recordId,
            }]
        } else {
            this.rows = [{
                rol: this.propiedad.rol,
                id_direcc: this.propiedad.id_direcc,
                folio: this.propiedad.folio,
                calle: this.propiedad.calle,
                calle_num: this.propiedad.calle_num,
                direccion_completa: this.propiedad.calle + " Nº" + this.propiedad.calle_num,
                direc_complemento: this.propiedad.direc_complemento,
                direc_compl_num: this.propiedad.direc_compl_num,
                loteo: this.propiedad.loteo,
                manzana: this.propiedad.manzana,
                plano: this.propiedad.plano,
                ubicacion: this.propiedad.ubicacion,
                recordId: this.propiedad.recordId,
            }]
        }
        //console.log("this.rows save propiedad",this.rows)
        localStorage.setItem("propiedad", JSON.stringify(this.rows));
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
        this.dialog.closeAll();

    }

    savePropiedadMulti(direccion) {
        //console.log("save propiedad multi direccion ",direccion)
        $("#dir_modal2").modal("hide");
        this.actualRow = localStorage.getItem("propiedad");
        this.rows = JSON.parse(this.actualRow);
        this.rows = [{

            rol: direccion.rol ? direccion.rol : '',
            id_direcc: direccion.id_direcc ? direccion.id_direcc : '',
            folio: direccion.folio ? direccion.folio : '',
            calle: direccion.calle ? direccion.calle : '',
            calle_num: direccion.calle_num ? (direccion.calle_num == 0 ? '' : direccion.calle_num) : '',
            direccion_completa: direccion.direccion_completa ? direccion.direccion_completa : '',
            direc_complemento: direccion.direc_complemento ? direccion.direc_complemento : '',
            direc_compl_num: direccion.direc_compl_num ? direccion.direc_compl_num : '',
            loteo: direccion.loteo ? direccion.loteo : '',
            manzana: direccion.manzana ? direccion.manzana : '',
            plano: direccion.plano ? direccion.plano : '',
            ubicacion: direccion.ubicacion ? direccion.ubicacion : '',
            recordId: direccion.recordId ? direccion.recordId : ''
        }]
        localStorage.setItem("propiedad", JSON.stringify(this.rows));
        //console.log("save propiedad multi this.rows",this.rows)
        this.propiedad = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', recordId: '' };
        this.rol.reset();
        this.dir.reset();
        this.num.reset();
        this.dialog.closeAll();
    }

    deletePropiedad(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("propiedad", JSON.stringify(this.rows));
            }
        }
    }

    traerCalles() {
        this._PropiedadService.traerCalles().subscribe(data => {
            this.options = data.calles;

        }, error => {
            console.log(error)
        })
    }
}